// extracted by mini-css-extract-plugin
module.exports = {"root":"LiveLookLayout_root__1Qcfm","header":"LiveLookLayout_header__1s2A7","sidebar":"LiveLookLayout_sidebar__dbGzv","content":"LiveLookLayout_content__eztT7"};